import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, Observable, of } from 'rxjs';
import { concatMap, finalize, map, tap } from 'rxjs';

type LoaderTags = 'tab';
@Injectable()
export class LoadingService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  private tabLoadingSubject = new BehaviorSubject<boolean>(false);

  public loading$: Observable<boolean> = combineLatest([this.loadingSubject.asObservable(), this.tabLoadingSubject.asObservable()]).pipe(map((loaders) => loaders.some((loading) => loading)));

  public showLoaderUntilCompleted<T>(obs$: Observable<T>): Observable<T> {
    return of(null).pipe(
      tap(() => this.loadingOn()),
      concatMap(() => obs$),
      finalize(() => this.loadingOff())
    );
  }

  public loadingOn(loaderTag?: LoaderTags): void {
    switch (loaderTag) {
      case 'tab':
        this.tabLoadingSubject.next(true);
        break;
      default:
        this.loadingSubject.next(true);
    }
  }

  public loadingOff(loaderTag?: LoaderTags): void {
    switch (loaderTag) {
      case 'tab':
        this.tabLoadingSubject.next(false);
        break;
      default:
        this.loadingSubject.next(false);
    }
  }
}
